var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 0.876,
    y2: 0.347,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c8ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078c5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13005",
    "data-name": "Path 13005",
    d: "M36,0a7.082,7.082,0,0,0-4.129,1.331L3.071,21.946A7.412,7.412,0,0,0,0,27.977v36.66A7.282,7.282,0,0,0,7.2,72H64.8A7.282,7.282,0,0,0,72,64.638V27.977a7.413,7.413,0,0,0-3.071-6.031L40.129,1.331A7.082,7.082,0,0,0,36,0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail_Icon",
    "data-name": "Mail Icon",
    transform: "translate(-917 -282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13235",
    "data-name": "Group 13235",
    transform: "translate(917 282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13234",
    "data-name": "Group 13234",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13009",
    "data-name": "Path 13009",
    d: "M0,0H72V72H0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13006",
    "data-name": "Path 13006",
    d: "M80.206,50.67V22.905a7.282,7.282,0,0,0-7.2-7.362h-36.5a7.282,7.282,0,0,0-7.2,7.362V50.67l25.45,13.657Z",
    transform: "translate(898.245 272.179)",
    fill: "#9fe9f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13007",
    "data-name": "Path 13007",
    d: "M72.867,52.706H45.256a2.93,2.93,0,0,1,0-5.858H72.867a2.93,2.93,0,0,1,0,5.858",
    transform: "translate(889.869 252.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13008",
    "data-name": "Path 13008",
    d: "M59.863,83.749H45.256a2.93,2.93,0,0,1,0-5.858H59.863a2.93,2.93,0,0,1,0,5.858",
    transform: "translate(889.87 232.782)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9ce3ee5d80ea6e0cb4bf10337ac99036.svg";
export { ForwardRef as ReactComponent };